// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PriceDetails-priceDetailsFlex-L_PXo {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    gap: 12px;
    grid-gap: 12px;
}

.PriceDetails-cursorPointer-YwKqu {
    cursor: pointer;
}

.PriceDetails-promoCodeLsInfo-l9GWJ {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: start;
        -ms-flex-align: start;
            align-items: flex-start;
    -webkit-box-pack: start;
        -ms-flex-pack: start;
            justify-content: flex-start;
    gap: 6px;
    grid-gap: 6px;
    width: 100%;
    -webkit-box-flex: 1;
        -ms-flex-positive: 1;
            flex-grow: 1;
    text-align: start;
}

.PriceDetails-promoCodeLsInfo-l9GWJ img {
    position: relative;
    top: 2px;
}

.PriceDetails-priceSplitUpLoaderContainer-yTlbi{
    min-height: 200px;
    width: 100%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/components/BookingDetail/PriceDetails/PriceDetails.css"],"names":[],"mappings":"AAAA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAA8B;QAA9B,sBAA8B;YAA9B,8BAA8B;IAC9B,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,uBAA2B;QAA3B,oBAA2B;YAA3B,2BAA2B;IAC3B,QAAQ;IACR,aAAa;IACb,WAAW;IACX,mBAAY;QAAZ,oBAAY;YAAZ,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;AACZ;;AACA;IACI,iBAAiB;IACjB,WAAW;IACX,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;AACvB","sourcesContent":[".priceDetailsFlex {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 12px;\n    grid-gap: 12px;\n}\n\n.cursorPointer {\n    cursor: pointer;\n}\n\n.promoCodeLsInfo {\n    display: flex;\n    align-items: flex-start;\n    justify-content: flex-start;\n    gap: 6px;\n    grid-gap: 6px;\n    width: 100%;\n    flex-grow: 1;\n    text-align: start;\n}\n\n.promoCodeLsInfo img {\n    position: relative;\n    top: 2px;\n}\n.priceSplitUpLoaderContainer{\n    min-height: 200px;\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"priceDetailsFlex": `PriceDetails-priceDetailsFlex-L_PXo`,
	"cursorPointer": `PriceDetails-cursorPointer-YwKqu`,
	"promoCodeLsInfo": `PriceDetails-promoCodeLsInfo-l9GWJ`,
	"priceSplitUpLoaderContainer": `PriceDetails-priceSplitUpLoaderContainer-yTlbi`
};
module.exports = ___CSS_LOADER_EXPORT___;
